import React from "react";

// Une erreur au rendu démonte TOUT l'arbre React : écran noir, éditeur perdu de
// vue alors que le document, lui, est sauf dans IndexedDB. C'est arrivé en
// production le 2026-05-22 (« elements is not defined ») et le 2026-06-02
// (showExportDialog hors de portée). Cette frontière cantonne la panne à la zone
// où elle survient : le reste de l'éditeur continue de répondre.
//
// Limite à connaître : React n'attrape ici que les erreurs de RENDU. Une erreur
// levée dans un gestionnaire d'évènement ou une promesse (le bouton « Ajuster »
// muet du 2026-10-01) passe au travers — c'est le travail du linter `no-undef`.

// Après un déploiement, un onglet ouvert avant demande des fichiers JS qui
// n'existent plus : Vercel renvoie la page HTML à leur place (mesuré le
// 2026-10-04 sur deux vrais fichiers de la veille). Chaque navigateur le dit à
// sa façon. Dans ce cas « Réessayer » ne sert à rien — React.lazy garde l'échec
// en mémoire — seul un rechargement charge la nouvelle version.
export function estFichierPerime(erreur) {
  const message = String(erreur?.message ?? erreur ?? "");
  return /dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(message);
}

export default class ZoneProtegee extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidCatch(erreur, info) {
    // eslint-disable-next-line no-console
    console.error(`[ZoneProtegee] « ${this.props.nom} » a planté :`, erreur, info?.componentStack);
  }

  render() {
    const { erreur } = this.state;
    if (!erreur) return this.props.children;

    const { nom, className = "flex-1", style, onFermer } = this.props;
    const perime = estFichierPerime(erreur);

    return (
      <div className={className} style={style} role="alert">
        <div className="h-full w-full flex items-center justify-center p-6">
          <div className="max-w-xs flex flex-col items-center gap-3 text-center">
            <span className="text-[10px] font-mono uppercase tracking-widest text-white/40">{nom}</span>
            <p className="text-sm text-white/80">
              {perime ? "Une nouvelle version de LabelForge est en ligne." : "Ce panneau a rencontré une erreur."}
            </p>
            <p className="text-xs text-white/50">
              {perime
                ? "Rechargez la page pour l'ouvrir. Votre document est enregistré."
                : "Le reste de l'éditeur fonctionne, et votre document est enregistré."}
            </p>
            <div className="flex flex-wrap justify-center gap-2 pt-1">
              {!perime && (
                <button
                  type="button"
                  onClick={() => this.setState({ erreur: null })}
                  className="px-3 py-1.5 rounded-lg text-xs text-white/50 hover:text-white/90 hover:bg-white/10 transition-colors"
                >
                  Réessayer
                </button>
              )}
              {onFermer && (
                <button
                  type="button"
                  onClick={onFermer}
                  className="px-3 py-1.5 rounded-lg text-xs text-white/50 hover:text-white/90 hover:bg-white/10 transition-colors"
                >
                  Fermer
                </button>
              )}
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-forge-accent hover:bg-forge-accent-hover text-forge-bg transition-colors"
              >
                Recharger la page
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
